// Convertit un produit API (snake_case) vers le format d'affichage des composants
export const mapApiProduct = (d) => ({
  ...d,
  price: d.price_ttc,
  image: d.images?.[0],
  test: d.test_data,
});

// Catégories MASTER (section 10)
// ============================================================
// DONNÉES DE DÉMONSTRATION — TEST UNIQUEMENT (LOT 2)
// Ces données servent exclusivement à visualiser les interfaces.
// Elles ne constituent AUCUNE donnée Art Event définitive.
// Le catalogue réel sera saisi depuis l'administration Art Event.
// ============================================================

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1519225421980-715cb0215aed?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  coordination: "https://images.pexels.com/photos/4101413/pexels-photo-4101413.jpeg?auto=compress&cs=tinysrgb&w=1200",
  decoration: "https://images.pexels.com/photos/20013453/pexels-photo-20013453.jpeg?auto=compress&cs=tinysrgb&w=1200",
  jeux: "https://images.pexels.com/photos/7551316/pexels-photo-7551316.jpeg?auto=compress&cs=tinysrgb&w=1200",
  arche: "https://images.unsplash.com/photo-1712068534065-f56c36e21759?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  table: "https://images.unsplash.com/photo-1773370812331-4e534dcf0ce1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  vases: "https://images.unsplash.com/photo-1505941625782-5f8710bdd9f3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  vase2: "https://images.unsplash.com/photo-1546045465-a32f4e5f198c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  couple: "https://images.unsplash.com/photo-1783579084840-3c2657c45a8d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  couple2: "https://images.pexels.com/photos/32142669/pexels-photo-32142669.jpeg?auto=compress&cs=tinysrgb&w=1200",
  gazebo: "https://images.unsplash.com/photo-1523438885200-e635ba2c371e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  textile: "https://images.unsplash.com/photo-1529636798458-92182e662485?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  candles: "https://images.unsplash.com/photo-1613067532295-b4f1760616cd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  rustic: "https://images.pexels.com/photos/9816190/pexels-photo-9816190.jpeg?auto=compress&cs=tinysrgb&w=1200",
  outdoor: "https://images.pexels.com/photos/25916372/pexels-photo-25916372.jpeg?auto=compress&cs=tinysrgb&w=1200",
  croquet: "https://images.unsplash.com/photo-1766777020566-1c791e439a53?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

// Catégories MASTER (section 10)
export const CATEGORIES = [
  { slug: "arches-et-structures", name: "Arches et structures", image: IMAGES.arche },
  { slug: "vases-et-verrerie", name: "Vases et verrerie", image: IMAGES.vases },
  { slug: "mobilier", name: "Mobilier", image: IMAGES.outdoor },
  { slug: "textiles", name: "Textiles", image: IMAGES.textile },
  { slug: "signaletique", name: "Signalétique", image: IMAGES.rustic },
  { slug: "luminaires", name: "Luminaires", image: IMAGES.candles },
  { slug: "jeux-en-bois", name: "Jeux en bois", image: IMAGES.jeux },
  { slug: "accessoires", name: "Accessoires", image: IMAGES.vase2 },
];

// Produits TEST — prix et stocks fictifs, uniquement pour visualiser l'interface
export const PRODUCTS = [
  { slug: "arche-hexagonale-bois", name: "Arche hexagonale bois", category: "arches-et-structures", price: 120, image: IMAGES.arche, test: true },
  { slug: "arche-triangulaire-bois", name: "Arche triangulaire bois", category: "arches-et-structures", price: 110, image: IMAGES.gazebo, test: true },
  { slug: "fauteuil-emmanuel", name: "Fauteuil Emmanuel", category: "mobilier", price: 45, image: IMAGES.couple, test: true },
  { slug: "mange-debout-housse-lycra", name: "Mange-debout + housse lycra", category: "mobilier", price: 18, image: IMAGES.outdoor, test: true },
  { slug: "vase-dame-jeanne-15l", name: "Vase Dame-Jeanne 15L", category: "vases-et-verrerie", price: 8, image: IMAGES.vases, test: true },
  { slug: "vases-cylindriques", name: "Vases cylindriques", category: "vases-et-verrerie", price: 6, image: IMAGES.vase2, test: true },
  { slug: "voilage-arche", name: "Voilage pour arche", category: "textiles", price: 15, image: IMAGES.textile, test: true },
  { slug: "lanternes-blanches", name: "Lanternes blanches", category: "luminaires", price: 4, image: IMAGES.candles, test: true },
  { slug: "jeu-puissance-4-geant", name: "Jeu Puissance 4 géant", category: "jeux-en-bois", price: 35, image: IMAGES.croquet, test: true },
  { slug: "candy-bar-complet", name: "Candy bar complet", category: "accessoires", price: 65, image: IMAGES.rustic, test: true },
  { slug: "miroir-dore", name: "Miroir doré", category: "signaletique", price: 25, image: IMAGES.couple2, test: true },
  { slug: "chevalet-bois", name: "Chevalet bois", category: "signaletique", price: 12, image: IMAGES.table, test: true },
];

export const FORMULES_COORDINATION = [
  { id: 1, name: "Formule 1", price: 790, description: "Accompagnement et préparation en amont de votre mariage.", dayJ: false },
  { id: 2, name: "Formule 2", price: 1300, description: "Accompagnement renforcé dans la préparation de votre mariage.", dayJ: false },
  { id: 3, name: "Formule 3", price: 1900, description: "Accompagnement complet avec présence le jour J, jusqu'au dessert.", dayJ: true },
];

export const REALISATIONS = [
  { slug: "mariage-camille-romain", title: "Mariage de Camille & Romain", place: "Le Moulin d'Artres", tags: ["Coordination", "Décoration", "Mobilier", "Jeux"], image: IMAGES.table, test: true },
  { slug: "mariage-la-gentilhommiere", title: "Mariage champêtre", place: "La Gentilhommière", tags: ["Décoration", "Mobilier"], image: IMAGES.rustic, test: true },
  { slug: "ceremonie-laique", title: "Cérémonie laïque en extérieur", place: "Domaine — donnée TEST", tags: ["Arches", "Textiles"], image: IMAGES.arche, test: true },
];

export const AVIS_TEST = [
  { author: "Camille & Romain", text: "Avis de démonstration — le contenu réel sera fourni par Art Event.", rating: 5, test: true },
  { author: "Sophie & Julien", text: "Avis de démonstration — le contenu réel sera fourni par Art Event.", rating: 5, test: true },
  { author: "Laura & Martin", text: "Avis de démonstration — le contenu réel sera fourni par Art Event.", rating: 5, test: true },
];

export const BLOG_POSTS = [
  { slug: "article-test-1", title: "Article de démonstration", category: "Conseils", excerpt: "Contenu provisoire — le blog réel sera rédigé par Art Event.", image: IMAGES.table, test: true },
  { slug: "article-test-2", title: "Article de démonstration", category: "Décoration", excerpt: "Contenu provisoire — le blog réel sera rédigé par Art Event.", image: IMAGES.vases, test: true },
];

export const CLIENT_EVENTS = [
  {
    id: "EVT-TEST-01", title: "Mariage — donnée TEST", date: "19/09/2026", place: "Le Moulin d'Artres, Artres (59)",
    hasCoordination: true, status: "Confirmé",
    reservations: [{ ref: "CMD-TEST-132", status: "Confirmée", total: 890, acompte: 267, solde: 623 }],
  },
  {
    id: "EVT-TEST-02", title: "Anniversaire — donnée TEST", date: "14/03/2026", place: "Lieu TEST",
    hasCoordination: false, status: "En attente de finalisation",
    reservations: [{ ref: "CMD-TEST-140", status: "En attente de finalisation client", total: 320, acompte: 96, solde: 224 }],
  },
];

// ---------- ADMINISTRATION (données TEST) ----------

export const ADMIN_RESERVATIONS = [
  { ref: "CMD-2026-0451", client: "Amélie & Romain", event: "Mariage", date: "15/08/2026", total: 890, status: "Nouvelle demande" },
  { ref: "CMD-2026-0440", client: "Thomas & Anaïs", event: "Mariage", date: "30/08/2026", total: 1240, status: "Confirmée" },
  { ref: "CMD-2026-0432", client: "Julie Martin", event: "Anniversaire", date: "10/08/2026", total: 320, status: "En attente de solde" },
  { ref: "CMD-2026-0428", client: "Entreprise Dupont", event: "Séminaire", date: "05/08/2026", total: 580, status: "Modification demandée" },
  { ref: "CMD-2026-0421", client: "Marie Leroy", event: "Baptême", date: "02/08/2026", total: 245, status: "Passée" },
];

export const ADMIN_STATS = {
  nouvellesDemandes: 4, messages: 3, rendezVous: 2, alertesStock: 3,
  reservationsAVenir: 12, soldesARecevoir: "4 820,00 €", livraisonsSemaine: 5,
};

export const ADMIN_NOTIFICATIONS = [
  { id: 1, priority: "Urgent", text: "Acompte en attente (J-2) — réservation #CMD-2026-0451", date: "Aujourd'hui 09:12" },
  { id: 2, priority: "Urgent", text: "Conflit de disponibilité — Arche hexagonale bois", date: "Aujourd'hui 08:45" },
  { id: 3, priority: "Important", text: "Solde en attente (J-7) — #CMD-2026-0440", date: "Hier 16:30" },
  { id: 4, priority: "Important", text: "Retour en retard — #CMD-2026-0432", date: "Hier 10:15" },
  { id: 5, priority: "Information", text: "Nouveau message client — Claire Dupont", date: "Hier 09:02" },
  { id: 6, priority: "Information", text: "Nouvelle demande de réservation — #CMD-2026-0456", date: "16/08/2026" },
];

export const ADMIN_MESSAGES = [
  { id: 1, client: "Camille & Romain", subject: "Demande de renseignements décoration", status: "Nouveau", preview: "Message de démonstration — TEST.", date: "10:32" },
  { id: 2, client: "Julie Martin", subject: "Disponibilité arche hexagonale", status: "En attente", preview: "Message de démonstration — TEST.", date: "09:15" },
  { id: 3, client: "Société Innovatech", subject: "Location mobilier — séminaire", status: "En attente", preview: "Message de démonstration — TEST.", date: "Hier" },
  { id: 4, client: "Laura & Martin", subject: "Modification livraison", status: "Répondu", preview: "Message de démonstration — TEST.", date: "Hier" },
];

export const ADMIN_PAYMENTS = [
  { ref: "CMD-2026-0451", client: "Amélie & Romain", type: "Acompte 30 %", amount: 267, status: "À encaisser", due: "23/08/2026" },
  { ref: "CMD-2026-0440", client: "Thomas & Anaïs", type: "Solde 70 %", amount: 868, status: "À venir", due: "23/08/2026" },
  { ref: "CMD-2026-0432", client: "Julie Martin", type: "Solde 70 %", amount: 224, status: "En retard", due: "03/08/2026" },
  { ref: "CMD-2026-0421", client: "Marie Leroy", type: "Acompte 30 %", amount: 73.5, status: "Encaissé", due: "—" },
];

export const ADMIN_CATALOG = PRODUCTS.map((p, i) => ({
  ...p, ref: `TEST-${String(i + 1).padStart(3, "0")}`, owned: i % 3 === 0 ? 12 : i % 3 === 1 ? 4 : 20, engaged: i % 4,
}));

export const ADMIN_PLANNING_ROWS = ADMIN_CATALOG.slice(0, 8);
